// extracted by mini-css-extract-plugin
module.exports = {"header-link":"tag_header-link__2VSjT","header-link-active":"tag_header-link-active__3Bb9V","header-link-inactive":"tag_header-link-inactive__3yOZh"};